<template>
  <MainLayout class="publisher-series">
    <div class="container mw-960" slot="sub-header">
      <div class="row">
        <div class="col-sm-10">
          <nav class="navbar navbar-toggleable navbar-light">
            <ul class="nav navbar-nav">
              <li class="nav-item active">
                <router-link to="/publishers/series" class="nav-link typography--body-3">
                  {{ $t('publishers.sub_header.series') }}
                </router-link>
              </li>
              <li class="nav-item">
                <router-link to="/publishers/non-series-cards" class="nav-link typography--body-3">
                  {{ $t('publishers.sub_header.non_series_cards') }}
                </router-link>
              </li>
            </ul>
          </nav>
        </div>

        <div class="col-sm-2 hidden-xs-down">
          <div class="sub-header-btn-row">
            <button class="btn btn-primary new-series-btn float-right"
                    v-on:click="newSeriesModalIsShown = true">
              {{ $t('publishers.sub_header.new_series') }}
            </button>
          </div>
        </div>
      </div>
    </div>

    <div class="container mw-960 mt-27" slot="layout-body">
      <div class="row" v-if="loading">
        <div class="col-12 text-center">
          <LoadingBounce />
          <div class="typography--body-2 typography--color-disabled pb-5">
            {{ $t('common.loading') }}
          </div>
        </div>
      </div>

      <div class="row" v-else>
        <div class="col-12 text-center mb-5 pb-5" v-if="seriesList.length === 0">
          <div class="empty-list-text">
            <div class="typography--body-2 typography--color-disabled"
                 v-html="$t('publishers.no_series')">
            </div>
          </div>
        </div>

        <div class="col-sm-6 col-md-4 col-lg-3" v-for="series in seriesList" v-bind:key="series.id" v-else>
          <router-link v-bind:to="`/publishers/series/${series.id}`" tag="div" class="card-row">
            <SeriesItem v-bind:series="series" />
          </router-link>
        </div>

        <InfiniteLoading :on-infinite="onInfinite" ref="infiniteLoading" class="w-100">
          <div slot="spinner">
            <LoadingBounce></LoadingBounce>
            <div class="typography--body-2 typography--color-disabled pb-5">{{ $t('common.loading') }}</div>
          </div>

          <div slot="no-more" class="col-12 text-center mb-5 pb-5">
          </div>
        </InfiniteLoading>
        
      </div>
    </div>

    <div slot="modal-area">
      <NewSeriesModal
        v-if="newSeriesModalIsShown"
        v-bind:publisher-id="publisherId"
        v-on:cancel="newSeriesModalIsShown = false"
        v-on:ok="newSeriesModalIsShown = false"
      />
    </div>
  </MainLayout>
</template>

<script>
  import { mapGetters, mapActions } from 'vuex';
  import InfiniteLoading from 'vue-infinite-loading';
  import publisherOnly from '@/mixins/publisherOnly';
  import NewSeriesModal from '../components/NewSeriesModal';
  import SeriesItem from '../components/SeriesItem';

  export default {
    name: 'publisher-series',

    mixins: [
      publisherOnly,
    ],

    components: {
      InfiniteLoading,
      NewSeriesModal,
      SeriesItem,
    },

    data() {
      return {
        loading: false,
        newSeriesModalIsShown: false,
      };
    },

    computed: {
      ...mapGetters([
        'currentPublisherInfo',
        'seriesList',
      ]),

      publisherId() {
        return this.currentPublisherInfo.id;
      },
    },

    methods: {
      ...mapActions([
        'fetchPublisherSeries',
      ]),

      onInfinite() {
        const offset = parseInt(this.seriesList.length / 20, 10) * 20;
        const limit = 20;
        const params = {
          publisher_id: this.publisherId,
          offset,
          limit,
        };

        return this.fetchPublisherSeries(params)
          .then((seriesList) => {
            if (this.$refs.infiniteLoading) {
              this.$refs.infiniteLoading.$emit('$InfiniteLoading:loaded');

              if (seriesList.length < limit) {
                this.$refs.infiniteLoading.$emit('$InfiniteLoading:complete');
              }
            }
          });
      },
    },
  };
</script>



// WEBPACK FOOTER //
// src/app/publishers/views/PublisherSeries.vue